import styled, { keyframes } from "styled-components";

const slideDownAnimattion = keyframes`
  from {
    top: 0;
    opacity: 0;
  }

  to {
    top: 100%;
    opacity: 1;
  }
`;

export const ContainerOuter = styled.div`
    display: inline-flex;
    flex-shrink: 0;
    position: relative;
`;
export const Container = styled.div`
    display: inline-flex;
    flex-shrink: 0;
    height: 40px;
    background-color: rgba(255,255,255,0.15);
    padding: 0 15px 0 10px;
    border-radius: 4px;
    display: flex;
    align-items: center;
    cursor: pointer;
    &::after{
        content: "";
        border: solid #fff;
        border-width: 0 2px 2px 0;
        padding: 3px;
        transform: rotate(45deg);
        margin-left: 10px;
    }
`;
export const Flag = styled.span`
    width: 16px;
    height: 12px;
    flex-shrink: 0;
    margin-right: 10px;
    border-radius: 2px;
    overflow: hidden;
    > img{
        width: 100%;
        height: 100%;
        object-fit: cover;
    }
`;
export const Lang = styled.span`
    font-size: 11px;
    font-weight: 700;
    color: #fff;
`;
export const Details = styled.div`
    background-color: #fff;
    border-radius: 4px;
    box-shadow: 0 1px 7px 0 rgb(0 0 0 / 20%);
    padding: 16px 20px;
    position: absolute;
    right: 0;
    top: 100%;
    width: 287px;
    z-index: 20;
    animation: ${slideDownAnimattion} 0.3s ease-in-out forwards;
`;
export const Language = styled.div`
    display: flex;
    margin-top: 20px;
`;
export const LanguageCol = styled.div`
    flex: 1;
    h4{
        font-size: 12px;
        font-weight: 400;
        margin-bottom: 15px;
    }
    ul{
        display: grid;
        grid-template-columns: 1fr;
        gap: 12px;
    }
`;
export const Cta = styled.button`
  background: linear-gradient(131.54deg, #53B2FE -11.7%, #065AF3 158.39%);
  box-shadow: 0px 1px 7px rgba(0, 0, 0, 0.2);
  border-radius: 36px;
  height: 34px;
  display: flex;
  width: 100%;
  margin-top: 20px;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  font-weight: 900;
  text-transform: uppercase;
  color: #fff;
  flex-shrink: 0;
  outline: 0;
  border: 0;
  cursor: pointer;
  font-family: 'Lato';
`;